import { CrawlerStatus } from '@components/App/CrawlerStatus'
import type React from 'react'

import { useWorkspaces } from '../../hooks'
import {
  InfoBannerWrapper,
  NewProjectButtons,
  ProjectsList,
  ProjectsListHeader,
  ProjectsRows,
  SortSelect,
  ViewSwitcher,
} from './components'
import { useProjectsList, useProjectsView } from './hooks'
import css from './styles.module.css'

export const DashboardProjects: React.FC = () => {
  const { current, folderId } = useWorkspaces()

  const { projects, setSort, sort } = useProjectsList(folderId, current)
  const { setView, switchable, view } = useProjectsView()

  const archive = folderId === 'archive'

  if (!current) {
    return null
  }

  return (
    <div className={css.projects_container}>
      {!archive && <NewProjectButtons workspaceId={current.id} />}

      {/* A crawl that is still running or finished unopened — its window was closed,
          the tab too, or the save failed. Lost with the old dashboard (OCT-5314). */}
      {!archive && <CrawlerStatus />}

      <div className={css.projects_body}>
        {current.type === 'personal' && <InfoBannerWrapper />}

        <ProjectsListHeader
          archive={archive}
          workspaceId={current.id}
          folderId={folderId}
        >
          {!archive && <SortSelect value={sort} onChange={setSort} />}
          {switchable && <ViewSwitcher value={view} onChange={setView} />}
        </ProjectsListHeader>

        {view === 'list' ? (
          <ProjectsRows projects={projects} />
        ) : (
          <ProjectsList projects={projects} />
        )}
      </div>
    </div>
  )
}
